import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { getClassificationLabelClient } from '@/lib/api-clients';
import { queryKeys } from '@/lib/query-keys';
import type {
  CreateClassificationLabelRequest,
  UpdateClassificationLabelRequest,
} from '@vagusx/clients';

export function useLabels() {
  return useQuery({
    queryKey: queryKeys.classificationLabels.list(),
    queryFn: () => getClassificationLabelClient().list(),
  });
}

export function useCreateLabel() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateClassificationLabelRequest) =>
      getClassificationLabelClient().create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.classificationLabels.all });
      toast.success('Label created');
    },
  });
}

export function useUpdateLabel() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateClassificationLabelRequest }) =>
      getClassificationLabelClient().update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.classificationLabels.all });
      toast.success('Label updated');
    },
  });
}

export function useDeleteLabel() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => getClassificationLabelClient().deleteLabel(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.classificationLabels.all });
      toast.success('Label deleted');
    },
  });
}
